import { usePreferredColorScheme, useStorage } from '@vueuse/core';
import { computed, watch } from 'vue';

type themeOption = 'system' | 'light' | 'dark';
const themeSetting = useStorage<themeOption>('theme', 'system');
const preferredColor = usePreferredColorScheme();
const theme = computed(() => {
    if (themeSetting.value === 'system') {
        if (preferredColor.value === 'no-preference') {
            return 'dark';
        }
        return preferredColor.value;
    }
    return themeSetting.value;
});

function applyThemeClass(): void {
    document.documentElement.classList.remove('dark', 'light');
    document.documentElement.classList.add(theme.value);
}

function useTheme() {
    applyThemeClass();
    watch(theme, () => {
        applyThemeClass();
    });
}

if (typeof document !== 'undefined') {
    applyThemeClass();
}

export { type themeOption, themeSetting, theme, useTheme, applyThemeClass };
